export const FONT_THEME_STORAGE_KEY = 'erp-font-theme';

export type FontThemeId = 'be-vietnam-pro' | 'inter' | 'roboto';

export interface FontThemeOption {
  id: FontThemeId;
  label: string;
  family: string;
}

export const FONT_THEME_OPTIONS: FontThemeOption[] = [
  {
    id: 'be-vietnam-pro',
    label: 'Be Vietnam Pro',
    family: "'Be Vietnam Pro', sans-serif"
  },
  {
    id: 'inter',
    label: 'Inter (Kế toán)',
    family: "'Inter', sans-serif"
  },
  {
    id: 'roboto',
    label: 'Roboto (Kế toán)',
    family: "'Roboto', sans-serif"
  }
];

const DEFAULT_FONT_ID: FontThemeId = 'be-vietnam-pro';

export const getStoredFontThemeId = (): FontThemeId => {
  if (typeof window === 'undefined') return DEFAULT_FONT_ID;
  const stored = window.localStorage.getItem(FONT_THEME_STORAGE_KEY);
  if (stored === 'be-vietnam-pro' || stored === 'inter' || stored === 'roboto') {
    return stored as FontThemeId;
  }
  return DEFAULT_FONT_ID;
};

export const setStoredFontThemeId = (fontId: FontThemeId) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(FONT_THEME_STORAGE_KEY, fontId);
};

export const applyFontTheme = (fontId: FontThemeId) => {
  if (typeof document === 'undefined') return;
  const option = FONT_THEME_OPTIONS.find(opt => opt.id === fontId) || FONT_THEME_OPTIONS[0];
  document.documentElement.style.setProperty('--font-primary', option.family);
};
